'use strict';

module.exports = require('./src/');



// WEBPACK FOOTER //
// ./_rc-tabs-5.9.2/index.js